var checkedListObj = {};
var arrayData = [];
var arrayData2 = [];
var _colModelData = [];
var _countryNames = [];
var _countryAdm3 = [];
var _tableData = [];
var _rowExample = [];
var dropdownValues = [];
var minDropdown = 0;
var maxDropdown = 0;
var surveySelectorDropdown = '';
var minYear, maxYear;
var objTemp = { countryName: '', countryAdm3: '' };
var firstPass = true;

var styleDropdowns = function (selector) {
  var selector = $('#' + selector);
  $(selector).selectmenu();
  var listNode = '#' + selector + '-menu li';
  $(selector).selectmenu('widget').addClass('jQuerySelectButton hollow');
  $(selector).selectmenu('menuWidget').addClass('jQuerySelectMenu hollow');
  $(selector)
    .selectmenu()
    .on('selectmenuselect', function (e, ui) {
      const surveyRange = statCompilerDashboard.getSurveyRange();
      // Creating the listeners for the dropdowns
      switch (e.target.id) {
        case 'dateMin':
          if (surveySelectorDropdown != '' && surveySelectorDropdown != null) {
            updateColumnSelection(
              surveyRange.min,
              surveyRange.max,
              surveySelectorDropdown
            );
          } else {
            updateColumnSelection(
              surveyRange.min,
              surveyRange.max,
              $('#surveySelector').val()
            );
          }
          break;
        case 'dateMax':
          updateColumnSelection(
            surveyRange.min,
            surveyRange.max,
            $('#surveySelector').val()
          );
          break;
        case 'surveySelector':
          updateColumnSelection(
            surveyRange.min,
            surveyRange.max,
            $('#surveySelector').val()
          );
          break;
      }
    });
};

/**
 * Update the dropdown values everytime we create the custom popup
 **/
function updateDropdownValue() {
  var dropdowns = ['dateMin', 'dateMax', 'surveySelector'];

  dropdowns.forEach(function (dropdownSelector) {
    var dropdownValue = $('#' + dropdownSelector).selectmenu()[0].value;
    $('#' + dropdownSelector + '-button .ui-selectmenu-text').text(
      dropdownValue
    );
  });
}

/**
 * createTable creates a table that is displayed in the customPopup
 * @return {[type]} [description]
 */
var createTable = function () {
  checkedListObj = {};
  arrayData = [];
  _colModelData = [];
  _countryNames = [];
  _countryAdm3 = [];
  _tableData = [];
  _rowExample = [];
  objTemp = { countryName: '', countryAdm3: '' };

  styleDropdowns('dateMin');
  styleDropdowns('dateMax');
  styleDropdowns('surveySelector');

  // Storing the survey
  var surveyRange = statCompilerDashboard.getSurveyRange();
  var selectedCountriesData = statCompilerDashboard.getSortedCountriesSurvey();
  sortAPIData(selectedCountriesData, ['name']);

  var fullSurveyRange = [Config.getUniversalString('country'), 'Country ID'];

  // Creating the model for jqgrid
  _colModelData.push({
    name: 'countryName',
    classes: 'countryRow',
    index: 'countryName',
    width: 90,
    sorttype: 'text',
    frozen: true,
    sortable: true,
    resizable: false,
  });
  _colModelData.push({
    name: 'countryAdm3',
    classes: 'countryRowAdm3',
    index: 'countryAdm3',
    width: 90,
    sorttype: 'text',
    frozen: true,
    hidden: true,
    resizable: false,
  });

  var dropdownMin = document.getElementById('dateMin');
  var dropdownMax = document.getElementById('dateMax');
  var dropdownSurvey = document.getElementById('surveySelector');

  // Creating the years array by looping from the survey min year to max year
  for (var i = surveyRange.min; i <= surveyRange.max; i++) {
    // Adding the years to the dropdowns
    var optionMin = document.createElement('option');
    var optionMax = document.createElement('option');
    optionMin.text = optionMin.value = i;
    optionMax.text = optionMax.value = i;
    dropdownMin.add(optionMin);
    dropdownMax.add(optionMax);

    fullSurveyRange.push(String(i));

    _colModelData.push({
      name: i,
      index: i,
      width: 45,
      align: 'center',
      resizable: false,
      formatter: function (cellvalue, options, rowobject) {
        if (cellvalue.visibility == 1) {
          return (
            '<input id="custom_box_' +
            options.pos +
            rowobject.countryAdm3 +
            '" class="hidden" type="checkbox" value="' +
            cellvalue.visibility +
            '" offval="no" checked="checked" style="display: inline-block; ">' +
            '<label for="custom_box_' +
            options.pos +
            rowobject.countryAdm3 +
            '" style="padding: 3px 0px 10px 35px; position: relative; bottom: 3px"></label>' +
            '<p style="margin-top: 5px; margin-bottom: 4px;">' +
            cellvalue.survey +
            '</p>'
          );
        } else if (cellvalue.visibility == 0) {
          return (
            '<input id="custom_box_' +
            options.pos +
            rowobject.countryAdm3 +
            '" type="checkbox" class="hidden" value="' +
            cellvalue.visibility +
            '" offval="no" style="display: inline-block;"><label for="custom_box_' +
            options.pos +
            rowobject.countryAdm3 +
            '" style="padding: 3px 0px 10px 35px; position: relative; bottom: 3px"></label>' +
            '<p style="margin-top: 5px; margin-bottom: 4px;">' +
            cellvalue.survey +
            '</p>'
          );
        } else {
          return (
            '<input type="checkbox" value="' +
            cellvalue.visibility +
            '" offval="no" style="display: inline-block;">'
          );
        }
      },
      editoptions: { value: '1:0' },
      classes: 'check ' + i,
      formatoptions: { disabled: false },
    });

    // Creating an array of objects the size of the year range
    objTemp[i] = { visibility: 2, survey: null };
  }
  _rowExample.push(objTemp);

  var listSurvey = [];

  var _selectedCountriesCode = statCompilerDashboard.getSelectedCountryCodes();
  var indexCount = 0;

  for (var nIndex = 0; nIndex < selectedCountriesData.length; nIndex++) {
    // If the country has not been deactivated on the right side panel, continue
    if (
      _.indexOf(
        statCompilerDashboard.getCurrUnSelectedCountries(),
        selectedCountriesData[nIndex].name
      ) == -1
    ) {
      // Store the country name.
      _countryNames.push(selectedCountriesData[nIndex].name);
      _countryAdm3.push(selectedCountriesData[nIndex].alias);

      // Obtain which surveys are currently selected.
      var arrSurveys = selectedCountriesData[nIndex].value;

      // Creating a deep copy of the _rowExample array
      var rows = deepCopy(_rowExample);

      rows[0].countryName = selectedCountriesData[nIndex].name;
      rows[0].countryAdm3 = selectedCountriesData[nIndex].alias;

      // For every country, we have a new object with all years
      _tableData.push(rows);

      // Going through all selected surveys
      for (
        var nCurSurveyIndex = 0;
        nCurSurveyIndex < arrSurveys.length;
        nCurSurveyIndex++
      ) {
        var surveyName = getSurvey(
          selectedCountriesData[nIndex].value[nCurSurveyIndex].name
        );
        // Storing each survey used
        listSurvey.push(surveyName);

        var _surveyType = getSurvey(arrSurveys[nCurSurveyIndex].name);
        var _surveyYear = arrSurveys[nCurSurveyIndex].alias;

        if (arrSurveys[nCurSurveyIndex].value) {
          _tableData[indexCount][0][_surveyYear].survey = surveyName;
          // Setting checkboxes to true
          _tableData[indexCount][0][_surveyYear].visibility = 1;
        } else {
          _tableData[indexCount][0][_surveyYear].survey = surveyName;
          _tableData[indexCount][0][_surveyYear].visibility = 0;
        }
      }
      indexCount++;
    }
  }

  if ((minYear || maxYear) === undefined) {
    $('#dateMin').val(surveyRange.min);
    $('#dateMax').val(surveyRange.max);
  } else {
    $('#dateMin').val(minYear);
    $('#dateMax').val(maxYear);
  }

  var uniqueSurveys = _.uniq(listSurvey);

  for (var i = 0; i < uniqueSurveys.length; i++) {
    // Add base options
    if (i === 0) {
      var surveyOption = document.createElement('option');
      surveyOption.text = surveyOption.value = Config.getUniversalString('All');
      dropdownSurvey.add(surveyOption);
    }

    // Add survey options
    var surveyOption = document.createElement('option');
    surveyOption.text = surveyOption.value = uniqueSurveys[i];
    dropdownSurvey.add(surveyOption);
  }

  // Creating the table
  jQuery('#customTable').jqGrid({
    datatype: 'local',
    height: 450,
    // width: 900,
    // autowidth: true,
    shrinkToFit: false,
    colNames: fullSurveyRange,
    hoverrows: false,
    beforeSelectRow: function (rowid, e) {
      return false;
    },
    colModel: _colModelData,
    caption: Config.getUniversalString('surveySelector'),
  });

  var $tableElement = $('#customTable');

  for (var i = 0; i <= _tableData.length; i++)
    $tableElement.jqGrid('addRowData', i + 1, _tableData[i]);

  // Freeze columns AFTER rows are added so jqGrid's own initial height-sync
  // pass measures the actual rendered row heights.
  $tableElement.jqGrid('setFrozenColumns');

  // Bidirectional height sync: jqGrid's setFrozenColumns pass only syncs
  // data→frozen. A second pass with Math.max also handles frozen rows that
  // are taller than their data counterparts (e.g. "Central African Republic"
  // wraps to 3 lines in the 90px country column). Deferred 50 ms so the
  // browser finishes text-wrap layout before we measure.
  setTimeout(function () {
    $tableElement.find('tr.jqgrow').each(function () {
      var rowId = $(this).attr('id');
      var $dataRow = $(this);
      var $frozenRow = $('#customTable_frozen tr#' + rowId);
      var dataH = $dataRow.outerHeight();
      var frozenH = $frozenRow.outerHeight();
      var h = Math.max(dataH, frozenH);
      if (h > 0) {
        $dataRow.css('height', h + 'px');
        $frozenRow.css('height', h + 'px');
      }
    });
  }, 50);

  // Important styling
  $('.jqgfirstrow').addClass('hidden');
  var countryColumnWidth = $('#customTable_countryName').width();
  $('.countryRow').each(function () {
    $(this).width(countryColumnWidth);
  });

  // Hide all unchecked boxes
  $tableElement.find('input[value="2"]').hide();
  $tableElement.find('input[value="1"]').show();
  $tableElement.find('input[value="0"]').show();
  updateDropdownValue();

  // If all checkeboxes are unchecked, then disable the buttton
  $tableElement.find('.check input:checkbox').change(function () {
    if ($tableElement.find('.check input:checked').length === 0) {
      $('.customPopupOK').addClass('disabled');
      $('.customPopupOK').prop('disabled', true);
    } else {
      $('.customPopupOK').removeClass('disabled');
      $('.customPopupOK').prop('disabled', false);
    }
  });
};

function getSurvey(surveyName) {
  var survey = surveyName.split(' ');
  return survey[1];
}

function checkGrid() {
  var currDisplayType = statCompilerDashboard.getCurrentDisplayType();
  var bt = false;
  $('.customPopupClass').hide();
  var boolOneSelected = false;
  var currSelected = $('#customTable').jqGrid('getGridParam', 'data');

  var currCountry,
    oldCountryAdm3 = 'empty',
    oldCountryName;
  var checkboxes = $('.check').children();
  if (currSelected) {
    for (var i = 0; i < currSelected.length; i++) {
      var yearArr = [];
      for (key in currSelected[i]) {
        if (
          currSelected[i][key] === 0 ||
          currSelected[i][key].visibility === 0
        ) {
          yearArr.push(parseInt(key));
        } else if (
          currSelected[i][key] === 1 ||
          currSelected[i][key].visibility === 1
        ) {
          // At least one checkbox is checked
          boolOneSelected = true;
        }
      }
      var checkedListObj = {};
      checkedListObj[0] = [];
      checkedListObj['alias'] = currSelected[i].countryAdm3;
      checkedListObj['value'] = yearArr;
      checkedListObj['name'] = currSelected[i].countryName;
      arrayData.push(checkedListObj);
    }
  }
  statCompilerDashboard.setUnselectedCountries([]);
  statCompilerDashboard.setUnselectedCountries(arrayData);
  // if(!bt) {
  statCompilerDashboard.displayCustomSurveySelector(arrayData, false, true);
  // }

  $('.popupParent').addClass('hidden');
  if ($('#customPopup').length) {
    $('#customPopup').dialog('close');
  }
}

/**
 * Getting the last selection of the selected surveys from the custom popup selector
 * This function is only called when the map is being used
 **/
function getLastSelectionSurvey() {
  var boolOneSelected = false;
  arrayDataMap = [];
  var currSelected = $('#customTable').jqGrid('getGridParam', 'data');
  var lastSelectedSurvey = [];

  var currCountry,
    oldCountryAdm3 = 'empty',
    oldCountryName;
  var checkboxes = $('.check').children();
  var value = [];

  //TODO figure out why curSelected is undefined
  if (currSelected) {
    for (var i = 0; i < currSelected.length; i++) {
      var checkedListObj = { value: [] };
      var yearArr = [];

      for (var key in currSelected[i]) {
        if (
          currSelected[i][key].visibility === 1 ||
          currSelected[i][key] === 1
        ) {
          boolOneSelected = true;
          yearArr.push(parseInt(key));
          checkedListObj['alias'] = currSelected[i].countryAdm3;
          var aliasYear = { alias: yearArr[yearArr.length - 1] };
          checkedListObj['value'].push(aliasYear);
          checkedListObj['name'] = currSelected[i].countryName;
          // If the new key is bigger than the previous one, remove the previous one as we only
          // need to display the last selected survey.
          if (checkedListObj.value[0].alias < parseInt(key)) {
            checkedListObj.value.shift();
            arrayDataMap.pop();
          }

          arrayDataMap.push(checkedListObj);
        }
      }
    }

    // Return only the last selected survey
    updateMapData(arrayDataMap);
  }
}

function updateMapData(arrayDataMap) {
  window.loadMapBundle().then(function (mod) {
    var model = mod.MapModel;
    if (model.vm === undefined) {
      nationalData(arrayDataMap);
      // subnationalData(arrayDataMap);
    } else if (model.vm.nationalEnabled() == true) {
      nationalData(arrayDataMap);
    } else {
      subnationalData(arrayDataMap);
    }
  });
}

function subnationalData(arrayDataMap) {
  var subnationalMapData = statCompilerDashboard.getSubnationalMapData();
  var subnationalCIData = statCompilerDashboard.getSubnationalCIData();
  var arrCIData = JSON.parse(JSON.stringify(arrayDataMap));
  var aliasRemoved;
  var mapValues = [];
  var arrNationalCI = [];
  var mapDataValues = [];
  var finalMapValues = [];

  for (var i = 0; i < arrayDataMap.length; i++) {
    // Current selected year per country
    currAlias = arrayDataMap[i].value[0].alias;
    // Getting the value object containg year, survey and value for the selected survey
    var arrNationalAlias = nameValueLib.getValueEX(subnationalMapData, [
      arrayDataMap[i].alias,
    ]);
    if ([arrayDataMap[i].alias]) {
      // Getting the CI values for the selected survey
      arrNationalCI = nameValueLib.getValueEX(subnationalCIData, [
        arrayDataMap[i].alias,
      ]);
      if (aliasRemoved) {
        aliasRemoved = false;
      }
      for (var j = 0; j < arrNationalAlias.length; j++) {
        if (aliasRemoved) {
          aliasRemoved = false;
          break;
        }
        if (arrNationalAlias[j].alias === currAlias) {
          aliasRemoved = delete arrayDataMap[i].value[0].alias;
          if (aliasRemoved) {
            mapDataValues = [];
            arrCIData[i].value[0] = arrNationalCI[j];
            arrayDataMap[i].value[0] = arrNationalAlias[j];
            var mapDataValues = arrNationalAlias[j].value.map(function (x) {
              return x.value;
            });
            finalMapValues = finalMapValues.concat(mapDataValues);
          }
        }
      }
    }
  }
  var currDisplayType = statCompilerDashboard.getCurrentDisplayType();
  statCompilerDashboard.updateSubnationalMapCIData(arrCIData);
  statCompilerDashboard.updateSubnationalMapValues(finalMapValues);
  statCompilerDashboard.updateSubnationalMapData(arrayDataMap);
  statCompilerDashboard.displayData(currDisplayType, true);
}

function nationalData(arrayDataMap) {
  var arrNationalAllMapData = statCompilerDashboard.getNationalAllMapData();
  var arrNationalAllMapCIData = statCompilerDashboard.getNationalAllMapCIData();
  var arrCIData = JSON.parse(JSON.stringify(arrayDataMap));
  var aliasRemoved;
  var mapValues = [];
  var arrNationalCI = [];

  for (var i = 0; i < arrayDataMap.length; i++) {
    // Current selected year per country
    currAlias = arrayDataMap[i].value[0].alias;
    // Getting the value object containg year, survey and value for the selected survey
    var arrNationalAlias = nameValueLib.getValueEX(arrNationalAllMapData, [
      arrayDataMap[i].alias,
    ]);
    if ([arrayDataMap[i].alias]) {
      // Getting the CI values for the selected survey
      arrNationalCI = nameValueLib.getValueEX(arrNationalAllMapCIData, [
        arrayDataMap[i].alias,
      ]);
      if (aliasRemoved) {
        aliasRemoved = false;
      }
      for (var j = 0; j < arrNationalAlias.length; j++) {
        if (aliasRemoved) {
          aliasRemoved = false;
          break;
        }
        if (arrNationalAlias[j].alias === currAlias) {
          aliasRemoved = delete arrayDataMap[i].value[0].alias;
          if (aliasRemoved) {
            arrCIData[i].value[0] = arrNationalCI[j];
            arrayDataMap[i].value[0] = arrNationalAlias[j];
            mapValues.push(arrNationalAlias[j].value);
          }
        }
      }
    }
  }
  var currDisplayType = statCompilerDashboard.getCurrentDisplayType();
  statCompilerDashboard.updateNationalMapCIData(arrCIData);
  statCompilerDashboard.updateNationalMapValues(mapValues);
  statCompilerDashboard.updateNationalMapData(arrayDataMap);
  statCompilerDashboard.displayData(currDisplayType, true);
}

function updateColumnSelection(surveyMin, surveyMax, currSurvey) {
  var yearsNotInRange = [];
  var yearsInRange = [];
  minYear = minDropdown = parseInt($('#dateMin').val());
  maxYear = maxDropdown = parseInt($('#dateMax').val());
  surveySelectorDropdown = $('#surveySelector').val();

  // Update values for bookmark
  g_arrCurrSurveyRange[0] = minYear;
  g_arrCurrSurveyRange[1] = maxYear;

  for (var i = surveyMin; i <= surveyMax; i++) {
    yearsNotInRange.push(i);
  }

  // Create a sequence to loop through those years to check the checkboxes
  for (var currYear = minYear; currYear <= maxYear; currYear++) {
    yearsInRange.push(currYear);
    var currSurveyInputs = $('.check.' + currYear);
    var currYearInputs = $('.check.' + currYear + ' input');
    for (var i = 0; i < currYearInputs.length; i++) {
      var currSelection = currYearInputs[i];
      var currSelectionSurvey = currSurveyInputs[i].title;
      if (
        currSelection.value === '0' &&
        (currSelectionSurvey === currSurvey ||
          currSurvey === Config.getUniversalString('All'))
      ) {
        // Checkbox is now checked
        $(currSelection).trigger('click');
      } else if (
        currSelection.value === '1' &&
        currSelectionSurvey !== currSurvey &&
        currSurvey !== Config.getUniversalString('All')
      ) {
        $(currSelection).trigger('click');
      }
    }
  }

  // Similar to a left outer join
  var yearsToUncheck = _.difference(yearsNotInRange, yearsInRange);

  if (yearsToUncheck.length > 0) {
    // This for loop unchecks all selected surveys that are not within the min-max year range
    for (var i = 0; i <= yearsToUncheck.length; i++) {
      var currYearInputs = $('.check.' + yearsToUncheck[i] + ' input');
      var currSurveyInputs = $('.check.' + yearsToUncheck[i]);
      for (var j = 0; j < currYearInputs.length; j++) {
        var currSelection = currYearInputs[j];
        var currSelectionSurvey = currSurveyInputs[j].title;
        if (currSelection.value === '1' && currSelectionSurvey === currSurvey) {
          // Checkbox is now unchecked
          $(currSelection).trigger('click');
        } else if (currSelection.value === '1') {
          $(currSelection).trigger('click');
        }
      }
    }
  }
}

function selectBySurvey(selectedSurvey) {
  var currSurveyInputs = $('.check');
  for (var i = 0; i < currSurveyInputs.length; i++) {
    // Boolean if checkbox is checked or not
    var isChecked = $(
      '.' + currSurveyInputs[i].className.replace(' ', '.') + ' input'
    )[0].checked;
    if (currSurveyInputs[i].title === selectedSurvey && isChecked === false) {
      $(
        '.' + currSurveyInputs[i].className.replace(' ', '.') + ' input'
      ).trigger('click');
    } else if (currSurveyInputs[i].title !== selectedSurvey && isChecked) {
      $(
        '.' + currSurveyInputs[i].className.replace(' ', '.') + ' input'
      ).trigger('click');
    }
  }
  updateColumnSelection($('#dateMin').val(), $('#dateMax').val());
}

function deepCopy(obj) {
  if (Object.prototype.toString.call(obj) === '[object Array]') {
    var out = [],
      i = 0,
      len = obj.length;
    for (; i < len; i++) {
      out[i] = arguments.callee(obj[i]);
    }
    return out;
  }
  if (typeof obj === 'object') {
    var out = {},
      i;
    for (i in obj) {
      out[i] = arguments.callee(obj[i]);
    }
    return out;
  }
  return obj;
}
